import { Grid, Button, Box, IconButton } from '@mui/material';
import { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import LanguageIcon from './img/languageIcon.svg';
import ContactIcon from './img/contactIcon.svg';
import { topHeaderStyles as styledClasses } from './TopHeaderStyles';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import OrientalImage from '../../images/oriental-bank.svg';
import OrientalImageText from '../../images/logo-text.svg';
import OrientalImageTextDark from '../../images/FDIC-logo-dark.svg';
import { dgiMapping } from '../../services/dgiMapping';
import {
  HOME_VI,
  ESP,
  ENG,
  PERSONAL_INFO,
  FINANCE_INFO,
  LANGUAGE_ICON,
  CHANGE_LANGUAGE,
  USER_LOGO,
  HELLO,
  ORIENTAL_LOGO,
  DGIADDITIONAL_INFO,
  BUSINESS_COMP,
  BUSINESS_ACCOUNT_INFO,
  BUSINESS_SURI,
  BUSINESS_ADDITIONAL_INFO,
  BUSINESS_COMPLIANCE_INFO,
  BUSINESS_INFO,
  FUNDING_INFO,
  PRODUCT_INFO,
  COMPLIANCE_INFO,
  ADDRESS_INFO,
  CONTACT_INFO,
  ES,
  LIBRE_AHORRA_BUNDLE,
} from '../../constants';
import { businessMapping } from '../../services/businessMapping';
import { productTypeMapping } from '../../services/productTypeMapping';
import { commonTernary, isBundle, isWebComponentFlow } from '../commonCode';
import { DarkTheme, LightTheme } from '../../theme/globalTheme';
import { LanguageIcon as LangIcon, ThemeMoonIcon, FDICLogo } from '../../images/svg/CustomizedSVG';

export default function TopHeader(props) {
  const { setLanguage, firstName } = props;
  const [languageString, setLanguageString] = useState(ESP);
  const { t } = useTranslation();
  const baseContext = isWebComponentFlow();
  const { productName, isLightTheme } = baseContext;

  const location = useLocation();
  useEffect(() => {
    const storedProductName = localStorage.getItem('productName');
    if (!baseContext.productName && storedProductName) {
      baseContext.setProductName(storedProductName);
    }
  }, []);
  useEffect(() => {
    if (baseContext.productName) {
      localStorage.setItem('productName', baseContext.productName);
    }
  }, [baseContext.productName]);
  useEffect(() => {
    console.log({ pathname: location.pathname });
    if (location.pathname === '/' || location.pathname === '/home') {
      baseContext.setProductName('');
      localStorage.removeItem('productName');
    }
  }, [location.pathname]);

  useEffect(() => {
    if (firstName?.length === 0) {
      baseContext.setUserName('Guest');
    }
    if (firstName?.length > 0) {
      baseContext.setUserName(`${firstName}`);
    }
  }, [firstName]);

  useEffect(() => {
    if (baseContext.language === ES || baseContext.language === ESP) {
      setLanguageString(ENG);
      setLanguage(ESP);
    } else {
      setLanguageString(ESP);
      setLanguage(ENG);
    }
  }, [baseContext.language]);
  const setHeaderLanguage = () => {
    console.log({ languageString });
    baseContext.setSuriLang(true);
    if (languageString === ESP) {
      setLanguageString(ENG);
      setLanguage(ESP);
    } else {
      setLanguageString(ESP);
      setLanguage(ENG);
    }
  };
  const setAddressInfoPage = () => {
    if (dgiMapping(baseContext.productName)) {
      baseContext.setIsScreenThreeDirty(true);
      baseContext.setIsTrustInfoDirty(true);
      baseContext.setIsFinanceInfoDirty(true);
      baseContext.setIsFundingScreenDirty(true);
    } else {
      baseContext.setIsScreenThreeDirty(true);
      baseContext.setIsScreenFourDirty(true);
      baseContext.setIsScreenFiveDirty(true);
      baseContext.setIsFundingScreenDirty(true);
    }
  };
  const currentPageCondition = () => {
    if (baseContext.currentPage === BUSINESS_COMPLIANCE_INFO) {
      baseContext.setIsBusinessComplianceDirty(true);
      baseContext.setIsBusinessSuriDirty(true);
      baseContext.setIsBusinessAdditionalInfoDirty(true);
      baseContext.setIsBusinessAccountInfoDirty(true);
      baseContext.setIsBusinessCompDirty(true);
      baseContext.setIsDocChecklistDirty(true);
      baseContext.setIsCommercialProductUIDirty(true);
    }
    if (baseContext.currentPage === BUSINESS_ADDITIONAL_INFO) {
      baseContext.setIsBusinessAdditionalInfoDirty(true);
      baseContext.setIsBusinessAccountInfoDirty(true);
      baseContext.setIsBusinessCompDirty(true);
      baseContext.setIsDocChecklistDirty(true);
      baseContext.setIsCommercialProductUIDirty(true);
    }
    if (baseContext.currentPage === BUSINESS_SURI) {
      baseContext.setIsBusinessSuriDirty(true);
      baseContext.setIsBusinessAdditionalInfoDirty(true);
      baseContext.setIsBusinessAccountInfoDirty(true);
      baseContext.setIsBusinessCompDirty(true);
      baseContext.setIsDocChecklistDirty(true);
      baseContext.setIsCommercialProductUIDirty(true);
    }
    if (baseContext.currentPage === BUSINESS_ACCOUNT_INFO) {
      baseContext.setIsBusinessAccountInfoDirty(true);
      baseContext.setIsBusinessCompDirty(true);
      baseContext.setIsDocChecklistDirty(true);
      baseContext.setIsCommercialProductUIDirty(true);
    }
    if (baseContext.currentPage === BUSINESS_COMP) {
      baseContext.setIsBusinessCompDirty(true);
      baseContext.setIsDocChecklistDirty(true);
      baseContext.setIsCommercialProductUIDirty(true);
    }
    if (baseContext.currentPage === 'document-checklist') {
      baseContext.setIsDocChecklistDirty(true);
      baseContext.setIsCommercialProductUIDirty(true);
    }
    if (baseContext.currentPage === FINANCE_INFO) {
      baseContext.setIsFinanceInfoDirty(true);
      baseContext.setIsFundingScreenDirty(true);
    }
    if (baseContext.currentPage === DGIADDITIONAL_INFO) {
      baseContext.setIsTrustInfoDirty(true);
      baseContext.setIsFinanceInfoDirty(true);
      baseContext.setIsFundingScreenDirty(true);
    }
  };
  const sendLanguage = () => {
    setHeaderLanguage();
    if (baseContext.currentPage === CONTACT_INFO) {
      baseContext.setIsScreenOneDirty(true);
      baseContext.setIsScreenTwoDirty(true);
      baseContext.setIsScreenThreeDirty(true);
      baseContext.setIsScreenFourDirty(true);
      baseContext.setIsScreenFiveDirty(true);
      baseContext.setIsFundingScreenDirty(true);
    }
    if (baseContext.currentPage === PERSONAL_INFO) {
      baseContext.setIsScreenTwoDirty(true);
      baseContext.setIsScreenThreeDirty(true);
      baseContext.setIsScreenFourDirty(true);
      baseContext.setIsScreenFiveDirty(true);
      baseContext.setIsFundingScreenDirty(true);
    }
    if (baseContext.currentPage === ADDRESS_INFO) {
      setAddressInfoPage();
    }
    if (baseContext.currentPage === COMPLIANCE_INFO) {
      baseContext.setIsScreenFourDirty(true);
      baseContext.setIsScreenFiveDirty(true);
      baseContext.setIsFundingScreenDirty(true);
    }
    if (baseContext.currentPage === PRODUCT_INFO) {
      if (
        businessMapping(baseContext.productName) &&
        (productTypeMapping(baseContext.productType) === 'Checking Account' ||
          productTypeMapping(baseContext.productType) === 'Savings Account')
      ) {
        baseContext.setIsCommercialProductUIDirty(true);
      }
      baseContext.setIsFundingScreenDirty(true);
      baseContext.setIsScreenFiveDirty(true);
    }
    if (baseContext.currentPage === FUNDING_INFO) {
      baseContext.setIsFundingScreenDirty(true);
    }
    if (baseContext.currentPage === BUSINESS_INFO) {
      baseContext.setIsBusinessContactInfoDirty(true);
      baseContext.setIsBusinessComplianceDirty(true);
      baseContext.setIsBusinessSuriDirty(true);
      baseContext.setIsBusinessAdditionalInfoDirty(true);
      baseContext.setIsBusinessAccountInfoDirty(true);
      baseContext.setIsBusinessCompDirty(true);
      baseContext.setIsDocChecklistDirty(true);
      baseContext.setIsCommercialProductUIDirty(true);
    }
    currentPageCondition();
  };
  useEffect(() => {
    if (baseContext.isLightTheme) {
      baseContext.setTheme(LightTheme);
    } else {
      baseContext.setTheme(DarkTheme);
    }
  }, [baseContext.isLightTheme]);

  const handleTheme = () => {
    baseContext.setIsLightTheme(!baseContext.isLightTheme);
  };

  const bundleHeader = () => (
    <Grid
      container
      sx={{
        ...styledClasses.top_header,
        ...{ boxShadow: '0px 4px 12px 0px #44444414' },
        ...((isBundle(baseContext.productName) ||
          baseContext.flowTypeVerifyScreen === 'bundleLoginScreen') && {
          color: baseContext?.theme?.palette?.primary?.main,
          backgroundColor: baseContext?.theme?.palette?.headerBackground?.main,
          '@media (max-width:400px)': {
            width: '100%',
          },
        }),
      }}
    >
      <Box sx={styledClasses.leftHeaderSectionBundle}>
        <Box
          component="img"
          src={OrientalImage}
          alt="Oriental Logo"
          sx={styledClasses.orientalBundle}
        />
        <Box sx={styledClasses.fdicsideBundle}>
          {isLightTheme && !isBundle(productName) ? (
            <Box
              component="img"
              src={OrientalImageText}
              alt="FDIC Logo"
              sx={styledClasses.orientalfdicBundle}
            />
          ) : isLightTheme && isBundle(productName) ? (
            <FDICLogo />
          ) : !isLightTheme && !isBundle(productName) ? (
            <Box
              component="img"
              src={OrientalImageTextDark}
              alt="FDIC Logo"
              sx={styledClasses.orientalfdicBundle}
            />
          ) : (
            <FDICLogo color="#FFFFFF" subColor="#FFFFFF" />
          )}
        </Box>
      </Box>
      <Box sx={styledClasses.bundleMobileHeader}>
        {baseContext.currentPage !== 'etb-login' &&
          baseContext.currentPage !== 'otp-screen' &&
          baseContext.currentPage !== 'received-code' &&
          baseContext.currentPage !== '' && (
            <IconButton onClick={handleTheme}>
              <ThemeMoonIcon color={baseContext?.theme?.palette?.orientalPrimary?.main} />
            </IconButton>
          )}

        <Box sx={styledClasses.right_mobile_header_bundle}>
          <Button
            disableFocusRipple
            onClick={setHeaderLanguage}
            sx={{
              ...styledClasses.lang_change_button,
              ...(isBundle(baseContext.productName) && { fontWeight: 600 }),
            }}
            type="button"
            variant="subtitle1"
            aria-label={t(CHANGE_LANGUAGE, { defaultValue: CHANGE_LANGUAGE })}
          >
            <LangIcon
              heigth="25px"
              width="25px"
              color={baseContext?.theme?.palette?.orientalPrimary?.main}
            />
            {baseContext.location === HOME_VI && ENG}
            {languageString === ENG && baseContext.location !== HOME_VI && ENG}
            {languageString === ESP && baseContext.location !== HOME_VI && ESP}
          </Button>
        </Box>
      </Box>
    </Grid>
  );

  const defaultHeader = () => (
    <Grid container sx={styledClasses.top_header}>
      <a
        href="#main-content"
        aria-label="skip to main content"
        id="skipToMain"
        className="skiptocontent"
        tabIndex="0"
      >
        skip to main content
      </a>
      <Box>
        <Box sx={styledClasses.leftHeaderSection}>
          <Box
            component="img"
            src={OrientalImage}
            alt={ORIENTAL_LOGO}
            aria-label="Oriental Logo"
            sx={styledClasses.oriental}
          />

          <Box sx={styledClasses.right_mobile_header}>
            {baseContext.location !== HOME_VI ? (
              <Button
                disableFocusRipple
                data-testid="topHeader_btnid"
                onClick={sendLanguage}
                disabled={baseContext.location === HOME_VI}
                sx={styledClasses.lang_change_button}
                type="button"
                aria-label={t(CHANGE_LANGUAGE, { defaultValue: CHANGE_LANGUAGE })}
              >
                <Box
                  component="img"
                  src={LanguageIcon}
                  alt={LANGUAGE_ICON}
                  aria-label="Language Icon"
                  sx={styledClasses.language_icon}
                />
                {baseContext.location === HOME_VI && ENG}
                {languageString === ENG && baseContext.location !== HOME_VI && ENG}
                {languageString === ESP && baseContext.location !== HOME_VI && ESP}
              </Button>
            ) : (
              ''
            )}
          </Box>
        </Box>
        <div>
          <Box
            component="img"
            src={OrientalImageText}
            alt="FDIC Insured"
            aria-label="FDIC Insured"
            sx={styledClasses.orientalText}
          />
        </div>
      </Box>
      <Box
        sx={styledClasses.username_block}
        aria-label={`${t(HELLO, { defaultValue: HELLO })} ${t(baseContext.userName, {
          defaultValue: baseContext.userName,
        })}`}
      >
        {`${t(HELLO, { defaultValue: HELLO })} ${t(baseContext.userName, {
          defaultValue: baseContext.userName,
        })}`}
        <Box
          component="img"
          src={ContactIcon}
          alt={USER_LOGO}
          aria-label="User Logo"
          sx={styledClasses.profile_icon}
        />
      </Box>
    </Grid>
  );

  const topHeader = commonTernary(
    isBundle(baseContext.productName) || baseContext.flowTypeVerifyScreen === 'bundleLoginScreen',
    bundleHeader(),
    defaultHeader()
  );

  return topHeader;
}

TopHeader.propTypes = {
  firstName: PropTypes.string,
  setLanguage: PropTypes.func,
};
